$(document).ready(function(e){
  function initSections(){
    /*** Homepage Custom Slide ***/
    $(".shopify-section--custom-slideshow .img-blocks").not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
    });
    
  
    /*** Homepage Logo List ***/
    $(".shopify-section--custom-logo-list .logo-items").not('.slick-initialized').slick({
      slidesToShow: 6,
      slidesToScroll: 6,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: false
          }
        },
      ]
    });
  
    $(".shopify-section--custom-img-row .img-items").not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
      ]
    });
  
    $(".shopify-section--custom-featured-products .product-items").not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
      ]
    });
  
    $(".shopify-section--custom-unique-selling-position .columns.mobile-columns").not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: false
    });
  
    
    $(".shopify-section--custom-review .review-items").not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
      ]
    });

    if ( $(".line-animations").length > 0 ){
      var firstScrollTop, lastScrollTop, intervalScrollValue;
      var lineNum = document.querySelectorAll(".line-animations .line-item").length;
      
      var bodyRect = document.body.getBoundingClientRect();
      var element = document.querySelector(".line-animations .line-item:nth-child(1)");
      var elemRect = element.getBoundingClientRect();
      firstScrollTop = elemRect.top - bodyRect.top;
      
      var element = document.querySelector(".line-animations .line-item:last-child");
      var elemRect = element.getBoundingClientRect();
      lastScrollTop = elemRect.top - bodyRect.top;
      
      firstScrollTop = firstScrollTop + 10;
      lastScrollTop = lastScrollTop + 400;
      intervalScrollValue = (lastScrollTop - firstScrollTop) / 5.0;
          
      
      window.onscroll = function () {
        var windowScrollTop = document.documentElement.scrollTop;
        windowScrollTop += 300;
        var lineIndex = 0;
        
        if ( windowScrollTop <= firstScrollTop ){
          lineIndex = 1;
        }
        else if ( windowScrollTop >= lastScrollTop ){
          lineIndex = lineNum;
        }
        else{
          lineIndex = Math.ceil((windowScrollTop - firstScrollTop) / 1.0 / intervalScrollValue);
        }
        
        if ( lineIndex > 5 ){
          lineIndex = 5;
        }
        
        var $currentElement = $(".line-animations .line-item:nth-child(" + lineIndex + ")");
        if ( $currentElement.hasClass("active") ){
          var imageId = $currentElement.data("image-id");
          $(".blockWrap.block1 .line-image").addClass("hidden");
          $("#" + imageId).removeClass("hidden");
        }
        else{
          $(".line-animations .line-item").removeClass("active");
          $currentElement.addClass("active");
          
          var imageId = $currentElement.data("image-id");
          $(".blockWrap.block1 .line-image").addClass("hidden");
          $("#" + imageId).removeClass("hidden");
        }
        
        
      }
    }
    
    
    
   
    
    
    $(".line-animations .line-item").click(function(e){
      $(".line-animations .line-item").removeClass("active");
      $(this).addClass("active");
      var imageId = $(this).data("image-id");
      
      
      $(".blockWrap.block1 .line-image").addClass("hidden");
      
      $("#" + imageId).removeClass("hidden");
    });


    $(".product-form-rc-container .selling_plan_button").click(function(e){
      var parent = $(this).closest(".product-form-rc-container");
      var value = $(this).attr("value");
      
      parent.find("input[name='selling_plan'][value=" + value + "]").prop("checked", true);
      parent.find("div.selling_plan_button").removeClass("active");
      parent.find("div.selling_plan_button[value=" + value + "]").addClass("active");
    });

    $(".subscribe-product-thumbs .subscribe-product-thumb").click(function(e){
      var productId = $(this).attr("data-product");
      
      $(".subscribe-products .subscribe-product-detail").removeClass("active");
      $(".subscribe-products .subscribe-product-detail[data-product='" + productId + "']").addClass("active");
    
      $(window).scrollTop(0);
    });
  }

  initSections();  

  $(document).on('shopify:section:load', e => {
    initSections();
  });
});

